import React from "react"

import {CopyableCaption} from "./CopyableCaption"

// The ID is what other systems (Genesys, the lake, an escalation) know this
// thread by, so it copies whole off either the card or the item view.
function ConversationIDLine({conversationID}: {conversationID: string}) {
	return (
		<CopyableCaption
			value={conversationID}
			label={`Conversation ${conversationID}`}
			ariaLabel={`Copy conversation ${conversationID}`}
			copiedNotice="Conversation ID copied"
		/>
	)
}

export {ConversationIDLine}
